import {
  apiClient,
  type MonthlyCustomerReportSummaryExEntity,
  type PageEntity
} from '@/libs/api'
import { type MonthlyCustomerReportSummariesRequestQuery } from '@/libs/api/types'

export type FetchMonthlyCustomerReportSummariesQuery = {
  tenantKey: string
  query: MonthlyCustomerReportSummariesRequestQuery
}

export type FetchMonthlyCustomerReportSummariesResponse = {
  data: MonthlyCustomerReportSummaryExEntity[]
  pagination: PageEntity | null
}

/**
 * 月次請求レポートの範囲集計を取得する (#4421)。
 * 荷主ごとに 1 行で、計上月をまたいでも 1 行にまとまる。
 */
export const fetchMonthlyCustomerReportSummaries = async (
  { tenantKey, query }: FetchMonthlyCustomerReportSummariesQuery,
  signal?: AbortSignal
): Promise<FetchMonthlyCustomerReportSummariesResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .monthly_customer_reports.summary.$get({ query, config: { signal } })
  return { data, pagination }
}
